import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["count", "fechaDesde", "fechaHasta", "excluirOrigenes", "excluirEnvios", "filtradoPaisEstricto"]
  static values = { url: String, origenes: String, locales: String }

  connect() {
    this.debounceTimer = null
    this.contar()
  }

  contar() {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this._fetchCount(), 300)
  }

  async _fetchCount() {
    const origenes = this.origenesValue
    if (!origenes || origenes === '[]') {
      this.countTarget.textContent = '--'
      return
    }

    const fechaDesde = this.hasFechaDesdeTarget ? this.fechaDesdeTarget.value : ''
    const fechaHasta = this.hasFechaHastaTarget ? this.fechaHastaTarget.value : ''

    const params = new URLSearchParams({
      origenes: origenes,
      fecha_desde: fechaDesde,
      fecha_hasta: fechaHasta
    })

    const locales = this.localesValue ? JSON.parse(this.localesValue) : []
    locales.forEach(l => params.append('locales[]', l))

    const excluirOrigenes = this._checkedExcluirOrigenes()
    if (excluirOrigenes.length > 0) {
      params.set('excluir_origenes', JSON.stringify(excluirOrigenes))
    }

    const excluirEnvioIds = this._checkedExcluirEnvioIds()
    excluirEnvioIds.forEach(id => params.append('excluir_envio_ids[]', id))

    if (this.hasFiltradoPaisEstrictoTarget && this.filtradoPaisEstrictoTarget.checked) {
      params.set('filtrado_pais_estricto', 'true')
    }

    try {
      const response = await fetch(`${this.urlValue}?${params}`)
      const data = await response.json()
      this.countTarget.textContent = `${data.count} (filtrado por país, antes de desduplicar emails y excluir lista Robinson)`
    } catch (error) {
      this.countTarget.textContent = 'Error'
    }
  }

  _checkedExcluirOrigenes() {
    if (!this.hasExcluirOrigenesTarget) return []

    const checkboxes = this.excluirOrigenesTarget.querySelectorAll('input[type="checkbox"]:checked')
    return Array.from(checkboxes).map(cb => {
      const parts = cb.value.split(':')
      if (parts.length === 3) {
        return { origen_type: parts[0], suscribible_type: parts[1], origen_id: parseInt(parts[2]) }
      }
      return { origen_type: parts[0], origen_id: parseInt(parts[1]) }
    })
  }

  _checkedExcluirEnvioIds() {
    if (!this.hasExcluirEnviosTarget) return []

    const checkboxes = this.excluirEnviosTarget.querySelectorAll('input[type="checkbox"]:checked')
    return Array.from(checkboxes).map(cb => cb.value)
  }
}
